import { xglobal } from '@polkadot/x-global';
export { packageInfo } from './packageInfo.js';
export const BigInt = typeof xglobal.BigInt === 'function' && typeof xglobal.BigInt.asIntN === 'function'
    ? xglobal.BigInt
    : (() => Number.NaN);
